// Icon paths — mirrored from design/v3/tokens.js (dvvbIconPaths).
// Single SVG <path d=...> stroke-style icons (lucide-shape).

import type { CSSProperties } from 'react';

export const iconPaths: Record<string, string> = {
  'layout-dashboard': 'M3 3h7v9H3V3zm11 0h7v5h-7V3zm0 9h7v9h-7v-9zM3 16h7v5H3v-5z',
  'list-checks': 'M3 5h3m12 0h3M9 5h6m-12 7h3m12 0h3M9 12h6M3 19h3m12 0h3M9 19h6',
  'bar-chart': 'M3 21h18M7 17v-6m5 6V7m5 10v-4',
  settings: 'M12 2v3m0 14v3M4.2 4.2l2.1 2.1m11.4 11.4l2.1 2.1M2 12h3m14 0h3M4.2 19.8l2.1-2.1m11.4-11.4l2.1-2.1M12 9a3 3 0 100 6 3 3 0 000-6z',
  refresh: 'M21 12a9 9 0 11-3-6.7L21 8m0-5v5h-5',
  alert: 'M12 3l10 17H2L12 3zm0 6v5m0 3v.5',
  'chevron-right': 'M9 6l6 6-6 6',
  'arrow-right': 'M5 12h14m-5-5l5 5-5 5',
  menu: 'M3 6h18M3 12h18M3 18h18',
  package: 'M3 7l9-4 9 4v10l-9 4-9-4V7zm0 0l9 4m0 0l9-4m-9 4v11',
  truck: 'M3 7h11v10H3V7zm11 3h4l3 3v4h-7v-7zm-8 10a2 2 0 110-4 2 2 0 010 4zm11 0a2 2 0 110-4 2 2 0 010 4z',
  activity: 'M22 12h-4l-3 9-6-18-3 9H2',
  receipt: 'M4 3h16v18l-3-2-3 2-2-2-2 2-3-2-3 2V3zm3 5h10M7 12h10M7 16h6',
  store: 'M3 7l2-4h14l2 4M3 7v12h18V7M3 7h18M9 13h6',
  search: 'M11 4a7 7 0 105.5 11.3L21 20M11 18a7 7 0 110-14',
  bell: 'M6 8a6 6 0 1112 0c0 7 3 9 3 9H3s3-2 3-9zm3 13a3 3 0 006 0',
  user: 'M12 12a4 4 0 100-8 4 4 0 000 8zm-8 9a8 8 0 0116 0',
  calendar: 'M3 8h18M5 4h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2zM8 2v4m8-4v4',
  clock: 'M12 3a9 9 0 100 18 9 9 0 000-18zm0 4v5l3 2',
  plus: 'M12 5v14m-7-7h14',
  x: 'M18 6L6 18M6 6l12 12',
  edit: 'M12 20h9M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4L16.5 3.5z',
  trash: 'M3 6h18M8 6V4h8v2m-9 0l1 15h8l1-15M10 11v6m4-6v6',
  logout: 'M15 21H6a2 2 0 01-2-2V5a2 2 0 012-2h9m6 9l-4-4m4 4l-4 4m4-4H10',
  check: 'M5 12l5 5L20 7',
  copy: 'M8 8h11v11H8V8zm-3 8H4a1 1 0 01-1-1V4a1 1 0 011-1h11a1 1 0 011 1v1',
  // Phase 6.C — schedule / movement-log / send 아이콘.
  sun: 'M12 4v2m0 12v2M4 12H2m20 0h-2M5.6 5.6l1.4 1.4m9.9 9.9l1.4 1.4M5.6 18.4l1.4-1.4m9.9-9.9l1.4-1.4M12 8a4 4 0 100 8 4 4 0 000-8z',
  sunrise: 'M12 3v6m-9 9h18M5.6 12.6l1.4-1.4m11.4 0l-1.4 1.4M3 18a9 9 0 0118 0M9 6l3-3 3 3',
  moon: 'M21 13a9 9 0 11-9-9 7 7 0 009 9z',
  knife: 'M3 21l5-5m0 0l13-13-3 5-10 8zm0 0l5-5',
  chef: 'M7 13a4 4 0 015-3.9 5 5 0 0110 1.4 4 4 0 010 6.5V21H7v-3.5A4 4 0 017 13z',
  send: 'M3 11l18-8-8 18-2-8-8-2z',
  message: 'M21 12a8 8 0 11-3-6.2L21 4l-1.5 4.5A7.9 7.9 0 0121 12z',
  'check-square': 'M9 11l3 3L22 4M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11',
  'check-circle': 'M22 11.1V12a10 10 0 11-5.9-9.1M22 4L12 14.1l-3-3',
  users: 'M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2m13-10a4 4 0 100-8 4 4 0 000 8zm6 10v-2a4 4 0 00-3-3.9M16 3.1a4 4 0 010 7.8',
};

export interface IconProps {
  name: string;
  size?: number;
  color?: string;
  strokeWidth?: number;
  style?: CSSProperties;
}

export function Icon({
  name,
  size = 20,
  color = 'currentColor',
  strokeWidth = 1.75,
  style,
}: IconProps) {
  const d = iconPaths[name] ?? iconPaths.alert!;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flexShrink: 0, ...style }}
      aria-hidden
    >
      <path d={d} />
    </svg>
  );
}

export interface LogoProps {
  size?: number;
  color?: string;
}

export function Logo({ size = 22, color = 'var(--primary-strong)' }: LogoProps) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        fontFamily: 'var(--font-sans)',
        fontWeight: 700,
        letterSpacing: '-0.02em',
        fontSize: size,
        color,
      }}
    >
      <span
        aria-hidden
        style={{
          width: size * 0.95,
          height: size * 0.95,
          borderRadius: 6,
          background:
            'linear-gradient(135deg, var(--primary-300), var(--primary-600))',
          display: 'inline-block',
        }}
      />
      <span style={{ fontSize: size * 0.78, color: 'var(--fg-1)' }}>dvvb</span>
    </span>
  );
}
